import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { GeneralButton } from '../../../common/ui/GeneralButton';
import { AppDesignSettingsWrapper } from './AppDesign.styles';
import { Delete, Replay, Upload } from '@mui/icons-material';
interface Props {
  isEditMode: boolean;
  isSaving: boolean;
  logoUrl: string | null | undefined;
  onLogoSelected: (url: string, file: File) => void;
  onResetClick: () => void;
  onDeleteClick: () => void;
}

export const AppDesignLogo = ({ isEditMode, isSaving, logoUrl, onLogoSelected, onResetClick, onDeleteClick }: Props) => {
  const { t } = useTranslation();
  const logoFileInputRef = useRef<HTMLInputElement>(null);

  const handleOpenInput = () => {
    logoFileInputRef.current && logoFileInputRef.current.click();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const dataUrl = URL.createObjectURL(file);
    onLogoSelected(dataUrl, file);
    e.target.value = '';
  };

  return (
      <AppDesignSettingsWrapper>
        <Stack spacing={2}>
          <Typography variant='h5'>
            {t("configurationPage.appDesign.companyLogo")}
          </Typography>
          <Box sx={{
            width: "150px",
            height: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            background: (theme) => theme.palette.backgroundColor.secondary,
            border: (theme) => `1px solid ${theme.palette.border.main}`,
            padding: "8px",
            overflow: "hidden"
          }}>
            {logoUrl
                ? <img src={logoUrl} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} alt="company logo"/>
                : t("configurationPage.appDesign.noCompanyLogo")
            }
          </Box>
          {isEditMode && !isSaving &&
              <Stack direction="row" spacing={1}>
                <Tooltip title={t("buttons.upload")}>
                  <GeneralButton appVariant="icon" onClick={handleOpenInput}>
                    <input
                        type="file"
                        ref={logoFileInputRef}
                        accept="image/gif, image/jpeg, image/png"
                        hidden
                        onChange={handleInputChange}
                    />
                    <Upload/>
                  </GeneralButton>
                </Tooltip>

                <Tooltip title={t("buttons.reset")}>
                  <GeneralButton appVariant="icon" onClick={onResetClick}>
                    <Replay/>
                  </GeneralButton>
                </Tooltip>

                <Tooltip title={t("buttons.delete")}>
                  <GeneralButton appVariant="icon" onClick={onDeleteClick}>
                    <Delete/>
                  </GeneralButton>
                </Tooltip>
              </Stack>
          }
        </Stack>
      </AppDesignSettingsWrapper>
  );
};